import React, {useRef, useState} from 'react';
import emailjs from '@emailjs/browser';
import Alert from 'react-bootstrap/Alert';

const Result = () => {
    return (
        <Alert variant="success" className="success-msg">
            Your Message has been successfully sent.
        </Alert>
    )
}

const FormOne = () => {

    const form = useRef();

    const [ result, showresult ] = useState(false);
    const [ phone, setPhone ] = useState("");
    const [ phoneError, setPhoneError ] = useState("");

    const handlePhoneChange = (e) => {
        const val = e.target.value.replace(/[^\d]/g, "").slice(0, 10);
        setPhone(val);
        if (val && val.length !== 10) {
            setPhoneError("Contact number must be exactly 10 digits.");
        } else {
            setPhoneError("");
        }
    };

    const sendEmail = (e) => {
        e.preventDefault();
        if (phone.length !== 10) {
            setPhoneError("Please enter a valid 10-digit contact number.");
            return;
        }
    
        emailjs.sendForm('service_yj5dgzp', 'template_hfduayo', form.current, 'WLENsTkBytC0yvItS');
          form.current.reset();
          setPhone("");
          setPhoneError("");
          showresult(true);
      };

        setTimeout(() => {
            showresult(false);
        }, 5000);


    return (
        <form ref={form} onSubmit={sendEmail} className="axil-contact-form">
        <div className="form-group">
            <label>Name</label>
            <input type="text" className="form-control" name="contact-name" placeholder="John Smith" required />
        </div>
        <div className="form-group">
            <label>Email</label>
            <input type="email" className="form-control" name="contact-email" placeholder="example@mail.com" required />
        </div>
        <div className="form-group mb--40">
            <label>Phone</label>
            <input 
                type="tel" 
                className="form-control" 
                name="contact-phone" 
                placeholder="Enter 10-digit contact number" 
                required 
                maxLength={10}
                value={phone}
                onChange={handlePhoneChange}
            />
            {phoneError && <div className="text-danger small mt-1">{phoneError}</div>}
        </div>
        <p className="small text-muted mb-3">
            By submitting, you agree to our{" "}
            <a href={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</a>.
        </p>
        <div className="form-group">
            <button type="submit" className="axil-btn btn-fill-primary btn-fluid btn-primary" name="submit-btn">Get Free Quote</button>
        </div>
        <div className="form-group">
            {result ? <Result /> : null}
        </div>

    </form>
    )
}

export default FormOne;